module.exports = __webpack_public_path__ + "img/projectList_bg5.8d243f4a.png";